import { IUser } from './user';

/**
 * Stripe Order Status
 */
export enum IStripeOrderStatus {
  paid = 'paid',
  prepared = 'prepared',
  shipped = 'shipped',
}

/**
 * Product in Stripe Order
 */
export interface IStripeOrderProduct {
  id: number;
  name: string;
  quantity: number;
  price: number;
  unit: string;
  total: number;
}

/**
 * Shipping Address
 */
export interface IShippingAddress {
  name?: string;
  surname?: string;
  address: string;
  city: string;
  postalCode: string;
  province: string;
  phone?: string;
}

/**
 * Stripe Order Metadata
 */
export interface IStripeOrderMetadata {
  customerEmail?: string;
  paymentStatus?: string;
  mode?: string;
  refundedAmount?: number;
  refundedAt?: string;
}

/**
 * Model definition for Stripe Order (DirectSale orders)
 */
export interface IStripeOrder {
  id: number;
  user?: IUser;
  stripeSessionId: string;
  stripePaymentIntentId?: string;
  orderNumber: string;
  productsWithQuantity: IStripeOrderProduct[];
  shippingAddress: IShippingAddress;
  shippingCost: number;
  subtotal: number;
  tax: number;
  total: number;
  currency: string;
  status: IStripeOrderStatus;
  date: Date;
  emailSent: boolean;
  metadata?: IStripeOrderMetadata;
}
